import React from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Container, Dimmer, Form, Icon, Label, Loader } from 'semantic-ui-react';
import ImageOnS3 from '../../../components/imageOnS3/imageOnS3.component';
import S3Manager from '../s3/s3manager';
import { CategoryModel } from '../../../entities/category.model';
import { ImageModel } from '../../../entities/image.model';
import MyForm from './form';
import MyFormState from './MyFormState';
import ImageCropperModal from '../../../components/image-cropper/imageCropper.modal';
import { buildBanner41WebpVariants, buildBannerXsWebp } from '../../../utils/imageVariants';

interface FormProps {
    match: any,
    history: any
}

interface CategoryFormState extends MyFormState {
    parentCategories: any[],
    newType: "",
    newUsage: "",
    model: CategoryModel,
    cropOpen41: boolean,
    cropImageSrc41: string,
    cropOpen43: boolean,
    cropImageSrc43: string,
    cropKeyPrefix: string,
    cropSourceFileSize41: number | null,
    cropSourceFileSize43: number | null,
}

class CategoryForm extends MyForm<FormProps, CategoryFormState> {
    entity = "category";

    private trackUnsavedUploads = (...keys: Array<string | undefined>) => {
        keys.forEach((key) => {
            if (!key) return;
            if (!this.imagesUploaded.includes(key)) {
                this.imagesUploaded.push(key);
            }
        });
    }

    constructor(props: any) {
        super(props);
        this.state = {
            model: new CategoryModel,
            successMsg: "",
            errorMsg: "",
            loading: true,
            editing: false,
            editingSlug: false,
            slugValid: true,
            imageObj: ImageModel.empty(),
            imageObjs: {
                lg: ImageModel.empty(), sm: ImageModel.empty(), xs: ImageModel.empty(),
                image1: ImageModel.empty(), image2: ImageModel.empty(), image3: ImageModel.empty(),
                image4: ImageModel.empty(), image5: ImageModel.empty(), image6: ImageModel.empty()
            },
            parentCategories: [],
            newType: "",
            newUsage: "",
            redirect: "",
            cropOpen41: false,
            cropImageSrc41: '',
            cropOpen43: false,
            cropImageSrc43: '',
            cropKeyPrefix: '',
            cropSourceFileSize41: null,
            cropSourceFileSize43: null,
        }
        this.onParentChange = this.onParentChange.bind(this);
        this.onItemChange = this.onItemChange.bind(this);
        this.onUsageChange = this.onUsageChange.bind(this);
    }

    componentDidMount() {
        this.fetchAllCategories();// used for parent dropdown and subcategories
        this.fetchUsages();
    }

    fetchAllCategories() {
        var token = localStorage.getItem('adminToken')
        if (!token || token === 'undefined') {
            this.setState({ redirect: this.loginUrl })
            return;
        }
        fetch(process.env.REACT_APP_API_URL + "list/category", {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                if (res.status === 401) {
                    this.setState({ redirect: this.loginUrl})
                } else {
                    res.json().then(res => {
                        if (res.data) {
                            let parentCategories: any[] = [];
                            let category: any;
                            res.data.forEach((c: any) => {
                                if (!c.parentId && (!this.props.match.params.id || (this.props.match.params.id !== String(c.id)))) {
                                    parentCategories.push({
                                        key: c.id,
                                        value: c.id,
                                        text: c.name
                                    });
                                }
                                if (this.props.match.params.id && this.props.match.params.id === String(c.id)) {
                                    category = c;
                                    category.active = category.active === 1;
                                    category.isFinal = category.isFinal === 1;
                                }
                            });
                            let newState = { model: this.state.model, parentCategories: parentCategories, editing: this.state.editing }
                            if (category) {
                                this.imageNamePrefix = String(category.name).toLowerCase().replace(/[^a-z ]/g, "").replace("  ", " ").replace(" ", "-").trim()
                                this.originalModel = category;
                                if (category.imageLgUrl) {
                                    this.state.imageObjs.lg = new ImageModel(undefined, category.imageLgUrl, true, true);
                                }
                                if (category.imageSmUrl) {
                                    this.state.imageObjs.sm = new ImageModel(undefined, category.imageSmUrl, true, true);
                                }
                                if (category.imageXsUrl) {
                                    this.state.imageObjs.xs = new ImageModel(undefined, category.imageXsUrl, true, true);
                                }
                                newState.model = Object.assign({}, category);
                                newState.editing = true;
                            }
                            this.setState(newState);
                        }
                    })
                }
            })
            .catch(err => console.error(err))
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    fetchUsages() {
        var token = localStorage.getItem('adminToken')
        if (!token || token === 'undefined') {
            this.setState({ redirect: this.loginUrl })
            return;
        }
        if (this.props.match.params.id) {
            fetch(process.env.REACT_APP_API_URL + `category/${this.props.match.params.id}/usage`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            })
                .then((res: any) => {
                    if (res.status === 401) {
                        this.setState({ redirect: this.loginUrl})
                    } else {
                        res.json().then((res: any) => {
                            if (res.data && res.data.length > 0) {
                                let model: any = this.state.model;
                                let types: any[] = [];
                                let usages: any[] = [];
                                res.data.forEach((u: any) => {
                                    u.active = true;
                                    if (u.type === 'type') {
                                        types.push(u);
                                    } else if (u.type === 'usage') {
                                        usages.push(u);
                                    }
                                });
                                this.originalModel.usages = Object.assign([], usages)
                                this.originalModel.types = Object.assign([], types)
                                model.types = types;
                                model.usages = usages;
                                this.setState(model);
                            }
                        })
                    }
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.setState({ loading: false });
                });
        }
    }

    onParentChange(e: any, drop: any) {
        let model: CategoryModel = this.state.model;
        model.parentId = drop.value;
        this.setState({ model: model });
    }

    onItemChange(e?: any) {
        this.setState({ newType: e.target.value });
    }

    onUsageChange(e?: any) {
        this.setState({ newUsage: e.target.value });
    }

    /** S3 key prefix shared by lg/sm/xs (from session or derived from existing imageLgUrl when editing). */
    getBannerKeyPrefix(): string | null {
        if (this.state.cropKeyPrefix) return this.state.cropKeyPrefix;
        const lg = this.state.model?.imageLgUrl;
        if (!lg || typeof lg !== 'string') return null;
        const base = lg.replace(/-lg\.webp$/i, '').replace(/-lg\.jpg$/i, '');
        return base.length > 0 ? base : null;
    }

    onBanner41Selected = (event: any) => {
        const file = event?.target?.files?.[0];
        if (!file) return;
        const src = URL.createObjectURL(file);
        const iso = new Date().toISOString();
        const prefix = `${this.entity}/${this.imageNamePrefix || 'category'}-${iso}`;
        if (event?.target) event.target.value = '';
        this.setState({ cropOpen41: true, cropImageSrc41: src, cropKeyPrefix: prefix, errorMsg: '', cropSourceFileSize41: file.size });
    };

    onBanner43Selected = (event: any) => {
        const file = event?.target?.files?.[0];
        if (!file) return;
        const prefix = this.getBannerKeyPrefix();
        if (!prefix) {
            this.setState({ errorMsg: 'Эхлээд өргөн баннер (4:1) зураг оруулна уу.' });
            return;
        }
        const src = URL.createObjectURL(file);
        if (event?.target) event.target.value = '';
        this.setState({
            cropKeyPrefix: prefix,
            cropOpen43: true,
            cropImageSrc43: src,
            errorMsg: '',
            cropSourceFileSize43: file.size,
        });
    };

    /** Wide step replaces lg+sm only — never queue xs for delete here. */
    pushOldWideBannerImagesForDelete() {
        if (this.state.imageObjs?.lg?.uploaded && this.state.imageObjs.lg.name) this.imagesToDelete.push(this.state.imageObjs.lg.name);
        if (this.state.imageObjs?.sm?.uploaded && this.state.imageObjs.sm.name) this.imagesToDelete.push(this.state.imageObjs.sm.name);
    }

    /** Xs-only step replaces xs — do not queue lg/sm or we delete still-used S3 keys on save. */
    pushOldXsBannerImageForDelete() {
        if (this.state.imageObjs?.xs?.uploaded && this.state.imageObjs.xs.name) this.imagesToDelete.push(this.state.imageObjs.xs.name);
    }

    onBanner41Cropped = async (blob: Blob) => {
        const { cropKeyPrefix } = this.state;
        if (!cropKeyPrefix) return;
        this.pushOldWideBannerImagesForDelete();
        this.setState({ loading: true });
        try {
            const { lg, sm } = await buildBanner41WebpVariants(blob);
            const keyLg = `${cropKeyPrefix}-lg.webp`;
            const keySm = `${cropKeyPrefix}-sm.webp`;
            await S3Manager.uploadImage(keyLg, lg, false, 'image/webp');
            await S3Manager.uploadImage(keySm, sm, false, 'image/webp');
            this.trackUnsavedUploads(keyLg, keySm);
            this.recordSaved = false;
            this.setState({
                model: {
                    ...this.state.model,
                    imageLgUrl: keyLg,
                    imageSmUrl: keySm,
                },
                imageObjs: {
                    ...this.state.imageObjs,
                    lg: new ImageModel(undefined, keyLg, true, true),
                    sm: new ImageModel(undefined, keySm, true, true),
                },
                cropOpen41: false,
                cropImageSrc41: '',
                cropSourceFileSize41: null,
            });
        } catch (err) {
            console.error(err);
            this.setState({ errorMsg: 'Зураг боловсруулахад алдаа гарлаа' });
        } finally {
            this.setState({ loading: false });
        }
    };

    onBanner43Cropped = async (blob: Blob) => {
        const cropKeyPrefix = this.getBannerKeyPrefix();
        if (!cropKeyPrefix) return;
        this.pushOldXsBannerImageForDelete();
        this.setState({ loading: true });
        try {
            const xsBlob = await buildBannerXsWebp(blob);
            const keyXs = `${cropKeyPrefix}-xs.webp`;
            await S3Manager.uploadImage(keyXs, xsBlob, false, 'image/webp');
            this.trackUnsavedUploads(keyXs);
            this.recordSaved = false;
            this.setState({
                model: {
                    ...this.state.model,
                    imageXsUrl: keyXs,
                },
                imageObjs: {
                    ...this.state.imageObjs,
                    xs: new ImageModel(undefined, keyXs, true, true),
                },
                cropOpen43: false,
                cropImageSrc43: '',
                cropSourceFileSize43: null,
            });
        } catch (err) {
            console.error(err);
            this.setState({ errorMsg: 'Зураг боловсруулахад алдаа гарлаа' });
        } finally {
            this.setState({ loading: false });
        }
    };

    addType() {
        if (this.state.newType) {
            let model: any = this.state.model;
            if (this.state.model.types) {
                for (let type of this.state.model.types) {
                    if (type.name === this.state.newType) {
                        this.setState({ newType: "" });
                        return;
                    }
                }
            } else {
                model.types = [];
            }
            model.types.push({ id: null, type: 'type', active: true, name: this.state.newType });
            this.setState({ model: model, newType: "" });
        }
    }

    removeType(index: number) {
        let model: any = this.state.model;
        if (model.types[index].id !== undefined && model.types[index].id !== null) {
            model.types[index].active = false;
        } else {
            model.types.splice(index, 1)
        }
        this.setState({ model: model, newType: "" });
    }

    addUsage() {
        if (this.state.newUsage) {
            let model: any = this.state.model;
            if (this.state.model.usages) {
                for (let usage of this.state.model.usages) {
                    if (usage.name === this.state.newUsage) {
                        this.setState({ newUsage: "" });
                        return;
                    }
                }
            } else {
                model.usages = [];
            }
            model.usages.push({ id: null, active: true, type: "usage", name: this.state.newUsage });
            this.setState({ model: model, newUsage: "" });
        }
    }

    removeUsage(index: number) {
        let model: any = this.state.model;
        if (model.usages[index].id !== undefined && model.usages[index].id !== null) {
            model.usages[index].active = false;
        } else {
            model.usages.splice(index, 1)
        }
        this.setState({ model: model, newUsage: "" });
    }

    validate(): boolean {
        this.setState({ successMsg: "" });
        if (!this.state.model.name) {
            this.setState({ errorMsg: "Категорийн нэрийг оруулна уу" });
            return false;
        }
        if (this.state.editingSlug || !this.state.slugValid || !this.state.model.slug) {
            this.setState({ errorMsg: "URL нэрийг шалгана уу." });
            return false;
        }
        if (!this.state.imageObjs.lg.file && !this.state.model.imageLgUrl) {
            this.setState({ errorMsg: "Өргөн баннер (4:1) зураг оруулна уу" });
            return false;
        }
        if (!this.state.imageObjs.sm.file && !this.state.model.imageSmUrl) {
            this.setState({ errorMsg: "Дунд хэмжээтэй зураг (4:1) — эхний тайралтын дараа үүснэ" });
            return false;
        }
        if (!this.state.imageObjs.xs.file && !this.state.model.imageXsUrl) {
            this.setState({ errorMsg: "Жижиг хэмжээтэй зураг (4:3) оруулна уу" });
            return false;
        }
        if (this.state.model.id !== undefined) {
            if (this.state.model.name === this.originalModel.name
                && this.state.model.shortName === this.originalModel.shortName
                && this.state.model.slug === this.originalModel.slug
                && this.state.model.parentId === this.originalModel.parentId
                && this.state.model.info === this.originalModel.info
                && this.state.imageObjs.lg.name === this.originalModel.imageLgUrl
                && this.state.imageObjs.sm.name === this.originalModel.imageSmUrl
                && this.state.imageObjs.xs.name === this.originalModel.imageXsUrl
                && this.state.model.types === this.originalModel.types
                && this.state.model.active === this.originalModel.active
                && this.state.model.isFinal === this.originalModel.isFinal
                && this.state.model.usages?.filter(u => u.active).map(u => u.name).join(",") === this.originalModel.usages?.map((u: any) => u.name).join(",")
                && this.state.model.types?.filter(u => u.active).map(u => u.name).join(",") === this.originalModel.types?.map((u: any) => u.name).join(",")
            ) {
                this.setState({ errorMsg: "Өөрчлөлт байхгүй байна" });
                return false;
            }
        }
        this.setState({ errorMsg: "" });
        return true;
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }
        return (
            <Container>
                <Dimmer active={this.state.loading} inverted>
                    <Loader size='medium'></Loader>
                </Dimmer>
                <h2>{!this.state.editing ? 'Шинэ' : ''} Категори</h2>
                <Form>
                    <Form.Group>
                        {this.state.successMsg ? <div className="success-msg">{this.state.successMsg}</div> : null}
                        {this.state.errorMsg ? <div className="error-msg">{this.state.errorMsg}</div> : null}
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <Form.Field required label='Категорийн нэр' control='input' value={this.state.model.name} 
                            onBlur={this.onNameBlur}
                            onChange={this.onNameChange} />
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <Form.Field label='Категорийн товч нэр' control='input' value={this.state.model.shortName} onChange={this.onShortNameChange} />
                    </Form.Group>
                    <Form.Group>
                        <div className="required field">
                            <label className="required">URL нэр</label>
                            { this.state.editingSlug ?
                            <React.Fragment>
                                <div className="flex-start">
                                    <Form.Input required value={this.state.model.slug || ""}
                                        onBlur={this.onSlugBlur}
                                        onChange={this.onSlugChange} />
                                    { this.state.slugValid ? null :
                                        <React.Fragment>
                                            <Icon name="warning circle" color='red' size='large'/>
                                            <span className="error-msg">URL нэр ашиглагдсан байна</span>
                                        </React.Fragment>
                                    }
                                    &nbsp;&nbsp;
                                    <Button className="cursor" color='orange'
                                        disabled={this.originalModel.slug === this.state.model.slug}
                                        onClick={this.postNewSlug}>Шалгах</Button>
                                    <Button className="cursor" onClick={this.cancelSlugChange}>Болих</Button>
                                </div>
                                <div>
                                    <br/>
                                    <Icon name="info circle" color="blue" />
                                    Зөвхөн англи үсэг болон - тэмдэг ашиглана
                                </div>
                            </React.Fragment>
                            :
                            <div>
                                <Label>{`${process.env.REACT_APP_DOMAIN}/category/${this.state.model.parentId ? "**parent**/" : ""}${this.state.model.slug}`}</Label>
                                { this.state.slugValid ?
                                    (this.state.model.slug && this.state.model.slug.length > 0) ?
                                        <Icon name="check circle" color='green' size='large'/> : null :
                                    <Icon name="warning circle" color='red' size='large'/>
                                }
                                &nbsp;&nbsp;
                                <Icon className="cursor" name="edit outline" size='large' onClick={this.toggleSlug}/>
                            </div>
                        }
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div className="field">
                            <label>Үндсэн категори</label>
                        </div>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <Form.Dropdown placeholder='Үндсэн категори' fluid labeled clearable selection options={this.state.parentCategories}
                            value={this.state.model.parentId}
                            onChange={this.onParentChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.TextArea label='Тайлбар' width="16" value={this.state.model.info} onChange={this.onInfoChange} />
                    </Form.Group>
                    <Form.Group className="flex-space-between">
                        <div className="field">
                            <label>
                                Том хэмжээтэй зураг (4:1) ба дунд хэмжээтэй зураг (4:1)
                            </label>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                            {this.state.model.imageLgUrl ? (
                                <span><small>Том</small><br /><ImageOnS3 imgKey={this.state.model.imageLgUrl} width='160px' height='40px' /></span>
                            ) : null}
                        </div>
                        <Form.Input control='input' type="file" accept="image/png, image/jpeg, image/webp" onChange={this.onBanner41Selected} />
                    </Form.Group>
                    <Form.Group className="flex-space-between">
                        <div className="field">
                            <label>
                                Жижиг хэмжээтэй зураг (4:3)
                            </label>
                        </div>
                        {this.state.model.imageXsUrl ? (
                            <ImageOnS3 imgKey={this.state.model.imageXsUrl} width='120px' height='90px' />
                        ) : null}
                        <Form.Input control='input' type="file" accept="image/png, image/jpeg, image/webp" onChange={this.onBanner43Selected} />
                    </Form.Group>
                    <Form.Group>
                        <div className="field">
                            <label>Бүтээгдэхүүний төрлүүд</label>
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <Form.Input value={this.state.newType} onChange={this.onItemChange} />
                        <Form.Button onClick={() => this.addType()}>Нэмэх</Form.Button>
                    </Form.Group>
                    <Form.Group>
                        <div className="category-types">
                            {this.state.model.types?.map((type: any, index: number) => {
                                return type.active ? <Label color='blue' key={type.name}>{type.name}&nbsp;&nbsp;
                                    <Icon className="cursor" name="trash" onClick={() => this.removeType(index)} />
                                </Label> : null
                            })}
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div className="field">
                            <label>Бүтээгдэхүүний хэрэглээ</label>
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <Form.Input value={this.state.newUsage} onChange={this.onUsageChange} />
                        <Form.Button onClick={() => this.addUsage()}>Нэмэх</Form.Button>
                    </Form.Group>
                    <Form.Group>
                        <div className="category-usages">
                            {this.state.model.usages?.map((usage: any, index: number) => {
                                return usage.active ? <Label color='blue' key={usage.name}>{usage.name}&nbsp;&nbsp;
                                    <Icon className="cursor" name="trash" onClick={() => this.removeUsage(index)} />
                                </Label> : null
                            })}
                        </div>
                    </Form.Group>
                    {/* <Form.Group>
                        <Form.Checkbox checked={this.state.model.isFinal} onChange={this.onIsFinalChange} label='Дор нь дэд категори байх уу'/>
                    </Form.Group> */}
                    <Form.Group>
                        <Form.Checkbox checked={this.state.model.active} onChange={this.onActiveChange} label='Идэвхитэй' />
                    </Form.Group>
                    <br />
                    <Form.Button disabled={this.state.loading} onClick={() => this.save()}>Хадгалах</Form.Button>
                </Form>
                <ImageCropperModal
                    key="category-banner-crop-41"
                    open={this.state.cropOpen41}
                    imageSrc={this.state.cropImageSrc41}
                    onClose={() => this.setState({ cropOpen41: false, cropImageSrc41: '', cropSourceFileSize41: null })}
                    onCropped={this.onBanner41Cropped}
                    aspect={4}
                    outputWidth={3200}
                    outputHeight={800}
                    cropTitle="Том / дунд зураг тайрах (4:1)"
                    sourceFileSizeBytes={this.state.cropSourceFileSize41 ?? undefined}
                />
                <ImageCropperModal
                    key={`category-banner-crop-43-${this.state.cropImageSrc43 || 'closed'}`}
                    open={this.state.cropOpen43}
                    imageSrc={this.state.cropImageSrc43}
                    onClose={() => this.setState({ cropOpen43: false, cropImageSrc43: '', cropSourceFileSize43: null })}
                    onCropped={this.onBanner43Cropped}
                    aspect={4 / 3}
                    outputWidth={1600}
                    outputHeight={1200}
                    cropTitle="Жижиг зураг тайрах (4:3)"
                    sourceFileSizeBytes={this.state.cropSourceFileSize43 ?? undefined}
                />
            </Container>
        );
    }
}

export default CategoryForm;